import { EnumCuponCategoria, EnumTipoCodigoCupon } from "../settings/enumConfig";
import {
    apiPromocionesDesactivarCupon,
    apiPromocionesGuardarCupon,
    apiPromocionesObtenerCupones,
} from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnHandleChangeText, fnHandleChangeUDecimal, fnHandleChangeUInteger } from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormCupon, getFormFiltroCupon, getModelCupon } from "../models/CuponModel";
import { green, red } from "@material-ui/core/colors";

import RedeemIcon from "@material-ui/icons/Redeem";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const CuponContext = createContext();

export function CuponProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post } = useRequest();

    const [listaCupones, setListaCupones] = useState([]);
    const [cuponSeleccionado, setCuponSeleccionado] = useState(getModelCupon());
    const [modalOpenFormCupon, setModalOpenFormCupon] = useState(false);
    const [modalOpenDetalleCupon, setModalOpenDetalleCupon] = useState(false);
    const [modalOpenEliminarCupon, setModalOpenEliminarCupon] = useState(false);
    const [formCupon, setFormCupon] = useState(getFormCupon());
    const [formFiltroCupon, setFormFiltroCupon] = useState(getFormFiltroCupon());

    const handleOpenFormCupon = (value) => {
        setModalOpenFormCupon(value);
    };

    const handleOpenDetalleCupon = (value) => {
        setModalOpenDetalleCupon(value);
    };

    const handleOpenEliminarCupon = (value) => {
        setModalOpenEliminarCupon(value);
    };

    const handleChangeCuponSeleccionado = (value) => {
        setCuponSeleccionado(value);
    };

    const handleChangeFormCuponText = fnHandleChangeText(formCupon, setFormCupon);
    const handleChangeFormCuponUInt = fnHandleChangeUInteger(formCupon, setFormCupon);
    const handleChangeFormCuponUDec = fnHandleChangeUDecimal(formCupon, setFormCupon);

    const handleChangeFormFiltroForm = fnHandleChangeText(formFiltroCupon, setFormFiltroCupon);

    const handleClickNuevoCupon = () => {
        setFormCupon(getFormCupon());
        setModalOpenFormCupon(true);
    };

    const handleClickDetalleCupon = () => {
        if (cuponSeleccionado.fiIdCupon === 0) {
            handleOpenAlert("Seleccione un cupón para ver el detalle");
            return;
        }
        setModalOpenDetalleCupon(true);
    };

    const handleClickEliminarCupon = () => {
        if (cuponSeleccionado.fiIdCupon === 0) {
            handleOpenAlert("Seleccione un cupón para eliminar");
            return;
        }
        setModalOpenEliminarCupon(true);
    };

    const handleClickRefrescarDatos = () => {
        fnObtenerCupones();
        setFormFiltroCupon(getFormFiltroCupon());
    };

    const handleClickFiltrarCupones = () => {
        const { txtTipoCupon, txtVigente } = formFiltroCupon;
        fnObtenerCupones("", txtTipoCupon.value, "", "", "", "", "", "", true, false, txtVigente.value);
    };

    const handleSubmitFormCupon = (e) => {
        fnPrevent(e);
        const {
            rdCuponCodigo,
            txtCodigoCupon,
            txtLongitudCupon,
            txtTipoCupon,
            txtMontoDescuento,
            txtPorcentajeDescuento,
            txtTotalCupones,
            txtDiasActivos,
            txtDescripcion,
        } = formCupon;

        const monto = parseFloat(txtMontoDescuento.value);
        const porcentaje = parseFloat(txtPorcentajeDescuento.value);
        const totalCupones = parseInt(txtTotalCupones.value);
        const diasActivos = parseInt(txtDiasActivos.value);

        const form = {
            ...formCupon,
            rdCuponCodigo: { ...rdCuponCodigo, error: rdCuponCodigo.value === "" },
            txtCodigoCupon: {
                ...txtCodigoCupon,
                error: rdCuponCodigo.value === EnumTipoCodigoCupon.personalizado && txtCodigoCupon.value === "",
            },
            txtLongitudCupon: {
                ...txtLongitudCupon,
                error: rdCuponCodigo.value === EnumTipoCodigoCupon.aleatorio && txtLongitudCupon.value === "",
            },
            txtTipoCupon: { ...txtTipoCupon, error: txtTipoCupon.value === "" },
            txtMontoDescuento: {
                ...txtMontoDescuento,
                error: txtTipoCupon.value === EnumCuponCategoria.DescuentoMonto && (isNaN(monto) || monto <= 0),
            },
            txtPorcentajeDescuento: {
                ...txtPorcentajeDescuento,
                error:
                    txtTipoCupon.value === EnumCuponCategoria.DescuentoPorcentaje &&
                    (isNaN(porcentaje) || porcentaje <= 0 || porcentaje > 100),
            },
            txtTotalCupones: { ...txtTotalCupones, error: isNaN(totalCupones) || totalCupones <= 0 },
            txtDiasActivos: {
                ...txtDiasActivos,
                error: txtDiasActivos.value !== "" && (isNaN(diasActivos) || diasActivos <= 0),
            },
            txtDescripcion: { ...txtDescripcion, error: txtDescripcion.value === "" },
        };

        setFormCupon(form);
        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entCreateCupon = {
            fiIdCuponCategoria: parseInt(txtTipoCupon.value),
            fsDescripcion: txtDescripcion.value,
            fsCodigo: rdCuponCodigo.value === EnumTipoCodigoCupon.personalizado ? txtCodigoCupon.value : null,
            fiLongitudCodigo:
                rdCuponCodigo.value === EnumTipoCodigoCupon.aleatorio ? parseInt(txtLongitudCupon.value) : null,
            fnMontoDescuento:
                txtTipoCupon.value === EnumCuponCategoria.DescuentoMonto
                    ? parseFloat(txtMontoDescuento.value) * 100
                    : null,
            fnPorcentajeDescuento:
                txtTipoCupon.value === EnumCuponCategoria.DescuentoPorcentaje
                    ? parseFloat(txtPorcentajeDescuento.value)
                    : null,
            fiTotalLanzamiento: parseInt(txtTotalCupones.value),
            fiDiasActivo: txtDiasActivos.value === "" ? null : parseInt(txtDiasActivos.value),
        };

        fnGuardarCupon(entCreateCupon);
    };

    const handleSubmitEliminarCupon = () => {
        fnElimninarCupon(cuponSeleccionado.fiIdCupon);
    };

    const fnObtenerCupones = async (
        piIdCupon = null,
        piIdCuponCategoria = null,
        psDescripcion = "",
        psCodigo = "",
        pdtFechaVencimientoInicio = "",
        pdtFechaVencimientoFin = "",
        pdtFechaCreacionInicio = "",
        pdtFechaCreacionFin = "",
        pbActivo = true,
        pbBaja = false,
        pbVigente = ""
    ) => {
        const payload = {
            loader: "Consultando cupones...",
            url:
                apiPromocionesObtenerCupones +
                "?piIdCupon=" +
                piIdCupon +
                "&piIdCuponCategoria=" +
                piIdCuponCategoria +
                "&psDescripcion=" +
                psDescripcion +
                "&psCodigo=" +
                psCodigo +
                "&pdtFechaVencimientoInicio=" +
                pdtFechaVencimientoInicio +
                "&pdtFechaVencimientoFin=" +
                pdtFechaVencimientoFin +
                "&pdtFechaCreacionInicio=" +
                pdtFechaCreacionInicio +
                "&pdtFechaCreacionFin=" +
                pdtFechaCreacionFin +
                "&pbActivo=" +
                pbActivo +
                "&pbBaja=" +
                pbBaja +
                "&pbVigente=" +
                pbVigente,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const resListaCupones = response.Result.map((cupon) => ({
                ...cupon,
                sStatus: (
                    <span>
                        <RedeemIcon
                            style={{ color: cupon.fbVigente === true ? green[500] : red[500], verticalAlign: "middle" }}
                        />
                    </span>
                ),
            }));
            setListaCupones(resListaCupones);
        }
    };

    const fnGuardarCupon = async (entCupon) => {
        const payload = {
            loader: "Guardando cupón...",
            url: apiPromocionesGuardarCupon + "?piIdUsuario=" + usuarioSesion.iIdUsuario,
            body: entCupon,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormCupon(false);
            setCuponSeleccionado(getModelCupon());
            setFormFiltroCupon(getFormFiltroCupon());
            await fnObtenerCupones();
        }
        fnPreventBlur();
    };

    const fnElimninarCupon = async (piIdCupon) => {
        const payload = {
            loader: "Eliminando cupón...",
            url: apiPromocionesDesactivarCupon + "?piIdCupon=" + piIdCupon + "&piIdUsuario=" + usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarCupon(false);
            setCuponSeleccionado(getModelCupon());
            setFormFiltroCupon(getFormFiltroCupon());
            await fnObtenerCupones();
        }
        fnPreventBlur();
    };

    return (
        <CuponContext.Provider
            value={{
                listaCupones,
                cuponSeleccionado,
                modalOpenFormCupon,
                modalOpenDetalleCupon,
                modalOpenEliminarCupon,
                formCupon,
                formFiltroCupon,
                handleOpenFormCupon,
                handleOpenDetalleCupon,
                handleOpenEliminarCupon,
                handleChangeCuponSeleccionado,
                handleChangeFormCuponText,
                handleChangeFormCuponUInt,
                handleChangeFormCuponUDec,
                handleChangeFormFiltroForm,
                handleClickNuevoCupon,
                handleClickDetalleCupon,
                handleClickEliminarCupon,
                handleClickRefrescarDatos,
                handleClickFiltrarCupones,
                handleSubmitFormCupon,
                handleSubmitEliminarCupon,
            }}
        >
            {props.children}
        </CuponContext.Provider>
    );
}

export function useCupon() {
    return useContext(CuponContext);
}
